// src/components/team-messages/KoreadorIntro.tsx
// Simple loading overlay shown when navigating to /team-messages.

import { useEffect, useState } from 'react';

interface KoreadorIntroProps {
  onDone: () => void;
}

export function KoreadorIntro({ onDone }: KoreadorIntroProps) {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      setExiting(true);
      setTimeout(onDone, 300);
    }, 800);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 50,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        background: '#0a0a0a',
        transition: 'opacity 300ms ease',
        opacity: exiting ? 0 : 1,
      }}
    >
      {/* Spinner */}
      <div
        style={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          border: '2px solid #2e2e2e',
          borderTopColor: '#ffffff',
          animation: 'ki-spin 0.7s linear infinite',
        }}
      />
      <style>{`@keyframes ki-spin { to { transform: rotate(360deg); } }`}</style>

      <span
        style={{
          fontSize: 11,
          color: '#5a5a5a',
          letterSpacing: '0.08em',
          fontFamily: '-apple-system, "Segoe UI", ui-sans-serif, Helvetica, Arial, sans-serif',
        }}
      >
        Loading messages
      </span>
    </div>
  );
}
